var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7489 6.6054C12.0837 6.27056 12.0837 5.72678 11.7489 5.39194L7.46292 1.10599C7.12808 0.771148 6.5843 0.771148 6.24946 1.10599C5.91462 1.44083 5.91462 1.98461 6.24946 2.31945L9.07551 5.14282H0.857191C0.383057 5.14282 0 5.52588 0 6.00001C0 6.47414 0.383057 6.8572 0.857191 6.8572H9.07283L6.25213 9.68057C5.91729 10.0154 5.91729 10.5592 6.25213 10.894C6.58697 11.2289 7.13076 11.2289 7.4656 10.894L11.7515 6.60808L11.7489 6.6054Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyLeftArrow);
export default __webpack_public_path__ + "static/media/greyLeftArrow.8dc1a53092cbbbcf17feae96360f13d5.svg";
export { ForwardRef as ReactComponent };